import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/index'
import { sync } from 'vuex-router-sync'
import VueQRCodeComponent from 'vue-qrcode-component'
const infiniteScroll =  require('vue-infinite-scroll')

sync(store, router)
import '@/assets/scss/main.scss'

Vue.config.productionTip = false
Vue.prototype.$eventHub = new Vue()

Vue.use(infiniteScroll)
Vue.component('qr-code', VueQRCodeComponent)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
